import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHead } from "../components/ui-bits";
import { toast } from "sonner";
import { SealCheck, DownloadSimple, File, FolderOpen } from "@phosphor-icons/react";

export default function Deliverables() {
  const [docs, setDocs] = useState([]);
  useEffect(() => { api.get("/documents").then((r) => setDocs(r.data.filter((d) => d.source === "agent"))); }, []);

  const download = async (d) => {
    try {
      const res = await api.get(`/documents/${d.id}/download`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a"); a.href = url; a.download = d.name; a.click();
      URL.revokeObjectURL(url);
    } catch { toast.error("Could not download file"); }
  };

  const groups = [...new Set(docs.map((d) => d.service || d.folder || "Other"))].sort();

  return (
    <div>
      <PageHead eyebrow="Final Documents from your CFO" title="Deliverables" />
      {docs.length === 0 ? (
        <div className="card p-10 text-center">
          <SealCheck size={34} className="mx-auto mb-3 text-[#00A86B]" weight="fill" />
          <p className="text-sm text-[#888]">No final deliverables yet. Your CFO team will share completed work here.</p>
        </div>
      ) : (
        <div className="space-y-5">
          {groups.map((g) => {
            const items = docs.filter((d) => (d.service || d.folder || "Other") === g);
            return (
              <div key={g} data-testid={`deliv-group-${g.toLowerCase()}`}>
                <p className="label mb-2 flex items-center gap-2"><FolderOpen size={14} className="text-[#002FA7]" /> {g} <span className="text-[#bbb]">({items.length})</span></p>
                <div className="card divide-y divide-black/10">
                  {items.map((d, i) => (
                    <div key={d.id} data-testid={`deliv-${g.toLowerCase()}-${i}`} className="flex items-center gap-3 px-5 py-3 hover:bg-black/[0.02]">
                      <File size={20} className="text-[#00A86B]" weight="fill" />
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium truncate">{d.name}</p>
                        <p className="text-xs text-[#888]">Shared by {d.uploaded_by} · {(d.uploaded_at || "").slice(0, 10)}</p>
                      </div>
                      <span className="text-[10px] uppercase font-bold tracking-wider text-[#00A86B] bg-[#00A86B]/10 px-2 py-0.5 rounded-sm">Deliverable</span>
                      <button data-testid={`deliv-dl-${g.toLowerCase()}-${i}`} onClick={() => download(d)} className="text-[#002FA7] hover:bg-[#002FA7]/10 p-1.5 rounded-sm"><DownloadSimple size={18} /></button>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
